import { render, staticRenderFns } from "./BannerPage.vue?vue&type=template&id=5c3d8d1d&scoped=true&"
import script from "./BannerPage.vue?vue&type=script&lang=js&"
export * from "./BannerPage.vue?vue&type=script&lang=js&"
import style0 from "./BannerPage.vue?vue&type=style&index=0&id=5c3d8d1d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3d8d1d",
  null
  
)

export default component.exports